import React from 'react';
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  IconButton,
} from '@material-ui/core';
import CloseIcon from '@material-ui/icons/Close';
import { SearchInput } from './MerchandisingWorkbenchUi';
import { useLocalizedMessage } from '../../../util/useLocalizedMessage';

export default function ConditionFieldPicker({
  open,
  query,
  onQueryChange,
  options,
  onPick,
  onClose,
}) {
  const t = useLocalizedMessage();
  return (
    <Dialog
      className="mp-dialog"
      open={open}
      onClose={onClose}
      maxWidth="sm"
      fullWidth
      aria-labelledby="mp-condition-field-picker-title"
    >
      <DialogTitle
        id="mp-condition-field-picker-title"
        className="mp-dialog-title-row"
      >
        <span>{t('merchandising.workbench.chooseProductFilter')}</span>
        <IconButton
          aria-label={t('merchandising.advancedPrototype.close')}
          onClick={onClose}
        >
          <CloseIcon />
        </IconButton>
      </DialogTitle>
      <DialogContent>
        <SearchInput
          value={query}
          onChange={onQueryChange}
          placeholder={t('merchandising.filter.search')}
          label={t('merchandising.filter.search')}
        />
        {options.length ? (
          <div className="mp-filter-option-grid">
            {options.map(option => (
              <button
                key={option.field}
                type="button"
                onClick={() => onPick(option)}
              >
                <strong>{option.label}</strong>
              </button>
            ))}
          </div>
        ) : (
          <div className="mp-value-picker-empty">
            {t('merchandising.selector.empty')}
          </div>
        )}
      </DialogContent>
      <DialogActions className="mp-dialog-actions">
        <Button variant="outlined" onClick={onClose}>
          {t('merchandising.advancedPrototype.cancel')}
        </Button>
      </DialogActions>
    </Dialog>
  );
}
